module.exports = __webpack_public_path__ + "static/img/book.939a524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book.jpg
// module id = st18
// module chunks = 0